export default __webpack_public_path__ + "static/media/eth_white.2536ae41.svg";